//instrumentTablePaging.directive.js
(function() {

    'use strict';

    angular
        .module('app.directives')
        .directive('instrumentTablePaging', instrumentTablePaging);

    instrumentTablePaging.$inject = [
        'HistoryService'
    ];

    function instrumentTablePaging(HistoryService) {
        var directive = {
            controller: controller,
            restrict: 'E',
            templateUrl: '/templates/instrumentTablePaging.html',
            scope: {
                data: '=',
                changeFunc: '=',
                activeTab: '='
            }
        };
        return directive;

        function controller($scope) {
            $scope.visiblePages = [];

            /**
             * Updates the visible pages array
             * Called when page or total pages changes
             */
            function updateVisiblePages() {
                if (!$scope.data || !$scope.data.paging) {
                    $scope.visiblePages = [];
                    return;
                }

                var currentPage = $scope.data.paging.page;
                var totalPages = $scope.data.paging.pages;
                var pages = [];

                // Account for prev/next buttons (~100px total), leaving ~856px for page buttons
                var maxButtons = Math.floor(856 / 50); // ~17 buttons max

                // If total pages fit within max width, show all
                if (totalPages <= maxButtons) {
                    for (var i = 1; i <= totalPages; i++) {
                        pages.push({ number: i, type: 'page' });
                    }
                    $scope.visiblePages = pages;
                    return;
                }

                // Calculate visible range around current page
                var halfRange = Math.floor(maxButtons / 2);
                var rangeStart = Math.max(1, currentPage - halfRange);
                var rangeEnd = Math.min(totalPages, rangeStart + maxButtons - 1);

                // Adjust range if we're near the end
                if (rangeEnd - rangeStart + 1 < maxButtons) {
                    rangeStart = Math.max(1, rangeEnd - maxButtons + 1);
                }

                // Add visible pages
                for (var j = rangeStart; j <= rangeEnd; j++) {
                    pages.push({ number: j, type: 'page' });
                }

                $scope.visiblePages = pages;
            }

            /**
             * Generates responsive page numbers array
             * Shows pages that fit within max width constraint (956px)
             * @returns {array} - Array of page objects with page number and type
             */
            $scope.getVisiblePages = function() {
                return $scope.visiblePages;
            };

            $scope.$watch('data.paging.page', function() {
                updateVisiblePages();
            });

            $scope.$watch('data.paging.pages', function() {
                updateVisiblePages();
            });


            updateVisiblePages();

            /**
             * Jumps to instrument group
             * @param {object} group - Instrument group data
             */
            $scope.jumpToGroup = function() {
                var elOffset;

                try {

                    // Jump to page header
                    if ($scope.activeTab){ //Get active tab and element offset
                        if ($('tab[index="' + $scope.activeTab.index + '"] [data-id="' + $scope.data.id + '"]').length) {
                            elOffset = $('tab[index="' + $scope.activeTab.index + '"] [data-id="' + $scope.data.id + '"]').offset().top - 100;
                        } else {
                            elOffset = $('[data-id="' + $scope.data.id.toString() + '"]').offset().top - 100;
                        }

                    } else {
                        elOffset = $('[data-id="' + $scope.data.id + '"]').offset().top - 100;
                    }

                    // Animate without changing active state
                    $('body, html').animate({
                        scrollTop: elOffset
                    }, 200);
                } catch (e) {
                    console.log(e);
                }
            };

            /**
             * Set new page
             * @param {any} index - String or integer
             */
            $scope.setPage = function(index) {
                try {

                    // Update current page index
                    if (index === 'next' && $scope.data.paging.page < $scope.data.paging.pages) {
                        $scope.data.paging.page++;
                    } else if (index === 'previous' && $scope.data.paging.page > 1) {
                        $scope.data.paging.page--;
                    } else if (typeof index === 'number') {
                        $scope.data.paging.page = index;
                    }

                    // Store action for history
                    HistoryService.storePagedGroup($scope.data.id, index);

                    // Trigger update function
                    $scope.changeFunc($scope.data);

                    // Jump to group
                    $scope.jumpToGroup();
                } catch (e) {
                    console.log(e);
                }
            };
        }
    }
})();